import { SiteSurveySignal } from '@/common/api/params/mediaDriver'
import { mediaAnalysisImage } from '@/common/app/modules/media/mediaAnalysis'
import { mediaAnalysisHistoryPath, mediaAnalysisPath } from '@/common/app/path'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import AiButton from '@/components/view/atoms/button/AiButton'
import Button from '@/components/view/atoms/button/Button'
import TextButton from '@/components/view/atoms/button/TextButton'
import SummaryHeading from '@/components/view/atoms/heading/SummaryHeading'
import Text from '@/components/view/atoms/text/Text'
import Area from '@/components/view/layouts/area/Area'
import AreaContent from '@/components/view/layouts/area/AreaContent'
import Line from '@/components/view/layouts/area/Line'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  siteId: number
  siteSurvey: SiteSurveySignal
}

// サイト調査の実施状況（3つの分析タブの使い分け）
const MediaSiteSurveyPanel = ({ siteId, siteSurvey }: Props) => {
  return (
    <>
      <SummaryHeading
        subText='まずは以下の3つの分析を行い、サイトの現状と競合把握を行うことから始めましょう。'
        subNode={
          <TextButton link={mediaAnalysisPath(siteId)} nowrap arrow>
            サイト現状分析
          </TextButton>
        }
      >
        サイト調査の実施状況
      </SummaryHeading>
      <div className='mb-4 flex flex-wrap gap-4'>
        {siteSurvey.subs.map((sub) => (
          <Area key={sub.key} tableWrap>
            <AreaContent>
              {sub.executed && (
                <div className='absolute top-2 right-2'>
                  <Badge size={12} badgeType={BadgeType.SQUARE_AI}>
                    実施済み
                  </Badge>
                </div>
              )}
              <ItemAlign direction='vertical' align='center' gapY={4}>
                <img src={mediaAnalysisImage(sub.key)} width={120} height={80} alt={sub.label} />
                <Text size={16} weight='bold'>
                  {sub.label}
                </Text>
                <Text size={12}>{sub.purpose}</Text>
              </ItemAlign>
              <Line />
              <div className='flex items-center justify-center'>
                {sub.executed ? (
                  <Button size='large' link={`${mediaAnalysisHistoryPath(siteId)}?type=${sub.key}`}>
                    分析結果を見る
                  </Button>
                ) : (
                  <AiButton size='large' link={mediaAnalysisPath(siteId)}>
                    {sub.label}を実行する
                  </AiButton>
                )}
              </div>
            </AreaContent>
          </Area>
        ))}
      </div>
    </>
  )
}

export default MediaSiteSurveyPanel
